import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import MyPerformanceOverview from './myPerformanceOverview';
// import FilterTable from '../components/filtertable';
import { useHistory,useLocation } from "react-router-dom";
import MyInvestorOverview from "./myInvestorList"
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  }

}));

function MyPerformance() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const location = useLocation();

  const myparam = location.state;
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let tabsList = ["Overview",'My Investor List']

  return (
    <div className={classes.root} className="pb30">
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" indicatorColor="primary"
          textColor="primary" TabIndicatorProps={{ style: { display: "none" } }}>
          {tabsList.map((text, index) => (
            <Tab label={text} key={index} {...a11yProps(index)} style={{ borderRadius: 20 }} />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
          <MyPerformanceOverview profile={myparam}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MyInvestorOverview/>
      </TabPanel>
      
    </div>
  );
}
export default MyPerformance;